import axios from 'axios'
import DataReady from './DataReady'

export default {
    install(Vue) {
        DataReady.markAs(false)
        Vue.mixin({
            beforeMount: function() {
                ++DataReady.lifeCycleCounter
                DataReady.checkIsReady()
            },
            mounted: function() {
                --DataReady.lifeCycleCounter
                DataReady.checkIsReady()
            }
        })

        axios.interceptors.request.use(
            config => {
                console.log(
                    '[data-ready] axios request success interceptor',
                    DataReady.ajaxCallCounter,
                    config
                )
                ++DataReady.ajaxCallCounter
                DataReady.checkIsReady()
                return config
            },
            error => {
                console.log(
                    '[data-ready] axios request error interceptor',
                    DataReady.ajaxCallCounter,
                    error
                )
                --DataReady.ajaxCallCounter
                DataReady.checkIsReady()
                return Promise.reject(error)
            }
        )

        axios.interceptors.response.use(
            response => {
                console.log(
                    '[data-ready] axios response success interceptor',
                    DataReady.ajaxCallCounter,
                    response
                )
                --DataReady.ajaxCallCounter
                DataReady.checkIsReady()
                return response
            },
            error => {
                console.log(
                    '[data-ready] axios response error interceptor',
                    DataReady.ajaxCallCounter,
                    error
                )
                --DataReady.ajaxCallCounter
                DataReady.checkIsReady()
                return Promise.reject(error)
            }
        )
    }
}
